// extracted by mini-css-extract-plugin
module.exports = {"roleCell":"roleCell__yefSm"};